import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getAccountCodeApi,
  saveAccountApi,
  deleteAccountApi,
} from "../../apiservice/accounts";

import { getAccountsApi } from "../../apiservice/setting";

export const fetchAccountsList = createAsyncThunk(
  "accounts/fetchAccountsList",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getAccountsApi(null);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : error.message);
    }
  }
);

export const createOrUpdateAccount = createAsyncThunk(
  "accounts/createOrUpdateAccount",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await saveAccountApi(payload);
      return res.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const deleteAccount = createAsyncThunk(
  "accounts/deleteAccount",
  async (acc_id, { rejectWithValue }) => {
    try {
      const res = await deleteAccountApi({ acc_id });
      return res.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchAccountCode = createAsyncThunk(
  "accounts/fetchAccountCode",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getAccountCodeApi();
      return res.data; 
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);